import { call, put, takeLatest } from 'redux-saga/effects'
import { PROFILE_UPDATE_REQUEST } from './constants'
import { getProfileUpdateFailureAction, getProfileUpdateSuccessAction } from './actions'
import remote from '../../../../services/remote';
import SentryManager from "../../../../monitoring/Sentry";

function* updateProfile (action) {
    try {
        const response = yield call(remote, {
            route: '/entrance/user',
            method: 'put',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(getProfileUpdateSuccessAction(response));
        } else {
            yield put(getProfileUpdateFailureAction(response));
        }
    } catch (e) {
        console.log(e);
        SentryManager.captureException(e);
    }
}

export default function* watchProfileSaga() {
    yield takeLatest(PROFILE_UPDATE_REQUEST, updateProfile);
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/User/Profile/saga.js